/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LISCaseListBlock = {
    readonly id?: number;
    /**
     * name of the block (1 in A1, 2 in A2, A in 1A (yosemite))
     */
    name?: string | null;
    lis_state?: LISCaseListBlock.lis_state | null;
    readonly specimen_id?: number;
}

export namespace LISCaseListBlock {

    export enum lis_state {
        UNPROCESSED = 'unprocessed',
        RACKED = 'racked',
        PROCESSED = 'processed',
        COOLING = 'cooling',
        EMBEDDED = 'embedded',
    }


}
